export default async function() {
    const mapElement = document.getElementById('map');
    if (!mapElement) {
        return
    }

    const googleClass = await GoogleMapsLoader.getMap();

    let map = new googleClass.maps.Map(mapElement, {
        zoom: 5,
        mapTypeControl: true,
        center: new googleClass.maps.LatLng(53.861928, -1.564854),
        mapTypeId: googleClass.maps.MapTypeId.ROADMAP
    });

    let infowindow = new googleClass.maps.InfoWindow();

    let marker, i;

    const locationData = await window.LocationDataLoader.get();

    for (i = 0; i < locationData.length; i++) {
        marker = new googleClass.maps.Marker({
            position: new googleClass.maps.LatLng(locationData[i]['lat'], locationData[i]['lng']),
            map: map,
            icon: await getMapIcon(locationData[i].brand)
        });

        googleClass.maps.event.addListener(marker, 'click', (function(marker, i) {
            return function() {
                infowindow.setContent(locationData[i]['name']);
                infowindow.open(map, marker);
            }
        })(marker, i));
    }

    googleClass.maps.event.addListener(map, 'click', function(event){
        this.setOptions({
        scrollwheel:true,
        draggable:true,
        });
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/fleet-and-business/modules/index/setup-map.js